import * as Types from 'src/actions/company/change-data/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';
import CompanyData from 'src/value-objects/CompanyData';

export interface ChangeCompanyData extends Action {
  type: Types.CHANGE_COMPANY_DATA;
  payload: CompanyData;
}

export type ChangeCompanyDataAction = ChangeCompanyData;

export const changeCompanyData: ActionCreator<ChangeCompanyData> = (company: CompanyData) => (
  {
    type: Types.CHANGE_COMPANY_DATA,
    payload: company
  }
);


// WEBPACK FOOTER //
// ./src/actions/company/change-data/ChangeCompanyData.actions.tsx